import { MiddlewareDtoImpl } from '../../../dto/middlewaredto';
import { GetMusicBoxContentsDto } from '../../../dto/musicboxcontents/getmusicboxcontentsdto';
import { MiddlewareAPIResponse } from '../../middlewareapiresponse';

export interface GetMusicBoxContentsResponse extends MiddlewareAPIResponse
{
    getMusicBoxContentsDto(): GetMusicBoxContentsDto;
}

export class GetMusicBoxContentsResponseDtoImpl extends MiddlewareDtoImpl implements GetMusicBoxContentsResponse
{
    private getMusicBoxContentsResponseDto : GetMusicBoxContentsDto;

    getMusicBoxContentsDto(): GetMusicBoxContentsDto
    {
        return this.getMusicBoxContentsResponseDto;
    }
    setMusicBoxContentsDto(getMusicBoxContentsResponseDto: GetMusicBoxContentsDto)
    {
        this.getMusicBoxContentsResponseDto = getMusicBoxContentsResponseDto;
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/wishlist/getmusicboxcontents/getmusicboxcontentsresponse.tsx